import request from './request';

const configService = {
    shows: (withAwardsDBConnection) => {
        withAwardsDBConnection = withAwardsDBConnection ?? false;
        return request({
            method: "get",
            url: "/configuration/shows",
            params: {
                withAwardsDBConnection
            }

        });
    },
    fileTypes: () => {
        return request({
            method: "get",
            url: "/configuration/filetypes"
        });
    }
};

export default configService;